import React, { useState } from 'react';
import { BiPlus } from 'react-icons/bi';

function AddUpdateEmployee(props) {

  return (
    <div className={`fixed inset-0 z-50 flex items-center justify-center ${props.show ? 'block' : 'hidden'}`} onClick={props.toggle}>
      <div className="bg-white w-full max-w-3xl mx-auto rounded-lg shadow-lg" onClick={(e) => e.stopPropagation()}>
        <div className="flex justify-between items-center p-4 border-b border-gray-200">
          <h2 className="text-xl">Create Invitation Code</h2>
          <button onClick={props.toggle} className="bg-teal-500 text-lg font-bold px-3 rounded hover:text-gray-700">
            &times;
          </button>
        </div>
        <div className="p-4 overflow-y-auto" style={{ minHeight: "30vh" }}>
          <div className="bg-white w-full sticky top-0 z-10 p-2" style={{ backgroundColor: '#ffffff', width: '100%' }}>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 p-2">
              <div>
                <label className="block text-sm font-medium text-gray-700">Name <span className="text-red-500">*</span></label>
                <input
                  type="text"
                  name="sender_name"
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">Email<span className="text-red-500">*</span></label>
                <input
                  type="text"
                  name="sender_name"
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">Role<span className="text-red-500">*</span></label>
                <input
                  type="text"
                  name="sender_name"
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="flex justify-end p-4 border-t border-gray-200">
          <button type='submit' className="bg-teal-500 text-white px-4 py-2 rounded-md hover:bg-teal-600" onClick={"submitHandler"}>Submit</button>
        </div>
      </div>
    </div>
  );
}

export default AddUpdateEmployee;
